/**
 * The mount point — the ONE component `routes.tsx` renders, which picks a
 * shell.
 *
 * ─── THE TWO-LINE CHANGE THAT TURNS THIS ON ─────────────────────────────────
 *
 * In `frontend/web/src/routes.tsx`:
 *
 *   1. add the import, beside the `DashboardLayout` one:
 *
 *          import { AppShell } from "@/wallet/shell";
 *
 *   2. swap the guarded layout element (the object with `children:` holding
 *      every app route):
 *
 *          element: (
 *            <RequireAuth>
 *   -          <DashboardLayout />
 *   +          <AppShell />
 *            </RequireAuth>
 *          ),
 *
 * That is the entire integration. Nothing else in `routes.tsx` moves: the route
 * array, the registry-generated paths, the admin and shell exceptions and the
 * `PagePlaceholder` fallback are all untouched, so `tests/parity.test.ts` sees
 * exactly the same route table it does today.
 *
 * ─── HOW TO REVERT ──────────────────────────────────────────────────────────
 *
 * Put `<DashboardLayout />` back on that one line. The `@/wallet` tree can stay
 * on disk; nothing imports it once that line is reverted, so it tree-shakes out
 * of the bundle.
 *
 * Short of reverting, `flag.ts` decides: phones (<768px) get the Wallet shell
 * and desktops keep the classic one, unless a browser has an explicit choice
 * from the avatar menu or `?shell=`. `VITE_WALLET_SHELL=off` at build time
 * forces the classic shell everywhere.
 *
 * ─── WHY A COMPONENT AND NOT `FLAG ? A : B` AT MODULE SCOPE ─────────────────
 *
 * The flag is flippable at runtime (a query param, and the "Switch to classic
 * layout" item in the avatar menu). A module-scope ternary is evaluated once at
 * import and would need a full reload to take effect; a component subscribed to
 * the flag store repaints on the spot. That matters because the whole point of
 * the flag is comparing the two shells back to back.
 */
import { WalletShell } from "./WalletShell";
import { forgetClassicLayoutChoice } from "./flag";

// One UI (owner's decision 2026-09-26): the Wallet-style shell for everyone.
// The classic layout and its per-browser switch are retired; a browser that
// had chosen "classic" is cleared once so it cannot keep showing the old UI.
forgetClassicLayoutChoice();

export function AppShell() {
  return <WalletShell />;
}
